import { GridCallbackDetails, GridCellParams, GridTreeNode, MuiEvent } from '@mui/x-data-grid-premium';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { DataGrid, Grid, IGridColDef } from 'src/components';
import { translate } from 'src/i18n/tHelper';
import VwHastauyari2DTO from 'src/models/HastaUyariModels/VwHastauyari2DTO';
import { HastaUyariListeApi, useHastaUyari2GuncelleMutation, useHastaUyari2ListesiQuery } from 'src/services/HastaUyariListesi/HastaUyariListeApi';
import { useAppDispatch, useAppSelector } from 'src/store';

const translatePath = "pages|hastaUyari";
const HastaUyari1ModulListesi = (): JSX.Element => {
    const state = useAppSelector(s => s.hastaUyari);
    const dispatch = useAppDispatch();

    const query = useHastaUyari2ListesiQuery({ hastaUyari1: state.activeRow?.id }, { skip: state.activeRow?.id > 0 ? false : true, refetchOnMountOrArgChange: true });
    const [guncelle, guncelleState] = useHastaUyari2GuncelleMutation();

    const columns: IGridColDef<VwHastauyari2DTO>[] = [
        {
            field: "moduladi",
            headerName: translate(translatePath, "İşlem No"),
            width: 100,
            flex: 1,
            minWidth: 200,
        },
        {
            field: "aktif",
            headerName: translate(translatePath, "Aktif"),
            type: "boolean",
            editable: true,
            width: 75,
            filterable: false,
            resizable: false,
            sortable: false,
            disableColumnMenu: true,
            valueGetter: (params) => { return params.row?.aktif === "E"; },
        },
    ];

    const onCellClick = async (params: GridCellParams<VwHastauyari2DTO, unknown, unknown, GridTreeNode>, event: MuiEvent<React.MouseEvent<HTMLElement, MouseEvent>>, details: GridCallbackDetails<any>) => {
        if (!query.isFetching && !guncelleState.isLoading) {
            if (params.field === "aktif") {
                const kayit: VwHastauyari2DTO = { ...params.row, aktif: params?.value ? "H" : "E", };
                await guncelle(kayit).unwrap().then((res) => {
                    dispatch(HastaUyariListeApi.util.updateQueryData("HastaUyari2Listesi", { hastaUyari1: state.activeRow?.id }, (draft) => {
                        return draft.map(x => x.id === res.id ? res : x);
                    }));
                }).catch(e => e);
            };
        }
    };

    return (
        <DataGrid
            enableQuickFilter
            sx={{ height: "55vh" }}
            editMode="cell"
            loading={query.isFetching || guncelleState.isLoading}
            columns={columns}
            rows={query.data || []}
            onCellClick={onCellClick}
        />
    );
};

export default HastaUyari1ModulListesi;